import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import toast from "../../utils/toast";
import {
  createAsset,
  deleteAsset,
  editAsset,
  getAssets,
  toggleAssetStatus,
  getAssetById,
} from "../../services/assetsService";

const initialState = {
  createdAsset: null,
  allPromotions: null,
  assetById: null,
  toggledAsset: null,
  updatedAsset: null,
  deletedAsset: null,
  loading: false,
};

const assetsSlice = createSlice({
  name: "asset",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createAsset?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.createdAsset = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getAssets?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.allPromotions = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getAssetById?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.assetById = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(toggleAssetStatus?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.toggledAsset = action?.payload?.data;
        toast.success(action?.payload?.message, {
          style: {
            background: "#E6F7FB",
            color: "#007EA7",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            padding: "12px 16px",
          },
          progressStyle: {
            background: "#007EA7",
          },
          icon: "✅",
        });
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(editAsset?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.updatedAsset = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(deleteAsset?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.deletedAsset = action?.payload?.data;
        toast.success(action?.payload?.data, {
          style: {
            background: "#E6F7FB",
            color: "#007EA7",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            padding: "12px 16px",
          },
          progressStyle: {
            background: "#007EA7",
          },
          icon: "✅",
        });
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder
      .addMatcher(
        isAnyOf(
          createAsset?.pending,
          getAssets?.pending,
          getAssetById?.pending,
          toggleAssetStatus?.pending,
          editAsset?.pending,
          deleteAsset?.pending
        ),
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        isAnyOf(
          createAsset.rejected,
          getAssets.rejected,
          getAssetById.rejected,
          toggleAssetStatus.rejected,
          editAsset.rejected,
          deleteAsset.rejected
        ),
        (state, action) => {
          state.loading = false;
          toast.error(action?.payload?.message);
        }
      );
  },
});

// export const {} = assetsSlice?.actions;
export default assetsSlice?.reducer;
